import React from 'react';

import { ButtonWrapper } from './ButtonWrapper';

export const Navigation = ({ isMultiPage, index, nextPage, previousPage, firstPage, lastPage, document, recordDocument }) => {
    return (
    <div className="container-contact100-form-btn">
      {isMultiPage && (!firstPage) && <ButtonWrapper onClick={() => { previousPage(index) }}>PRECEDENT</ButtonWrapper>}
      {isMultiPage && !lastPage && <ButtonWrapper onClick={() => { nextPage(index) }}>SUIVANT</ButtonWrapper>}
      {(lastPage || !isMultiPage) && <ButtonWrapper onClick={() => { recordDocument(document) }}>
        Valider
      </ButtonWrapper>}
      </div>
    )
}